import { ReactComponent as InstagramIcom } from '../../assets/icons/social/instagram.svg'
import { ReactComponent as TiktokIcom } from '../../assets/icons/social/tiktok.svg'
import { ReactComponent as FacebookIcon } from '../../assets/icons/social/facebook.svg'
import { ReactComponent as YoutubeIcon } from '../../assets/icons/social/youtube.svg'
import { ReactComponent as BabelioIcon } from '../../assets/icons/social/babelio.svg'
import { ReactComponent as BooknodeIcon } from '../../assets/icons/social/booknode.svg'
import { ReactComponent as LivraddictIcon } from '../../assets/icons/social/livraddict.svg'
import { ReactComponent as GoodreadsIcon } from '../../assets/icons/social/goodreads.svg'
import { ReactComponent as BlueskyIcon } from '../../assets/icons/social/bluesky.svg'
import { ReactComponent as GleephIcon } from '../../assets/icons/social/gleeph.svg'
import { ReactComponent as XIcon } from '../../assets/icons/social/x.svg'
import { ReactComponent as AmazonIcon } from '../../assets/icons/social/amazon.svg'
import { ReactComponent as FnacIcon } from '../../assets/icons/social/fnac.svg'
import { ReactComponent as DecitreIcon } from '../../assets/icons/social/decitre.svg'
// import { ReactComponent as CulturaIcon } from '../../assets/icons/social/cultura.svg'
import { ReactComponent as PlaceDesLibrairesIcon } from '../../assets/icons/social/place_des_libraires.svg'
import { ReactComponent as FuretDuNordIcon } from '../../assets/icons/social/furet_du_nord.svg'
import { ReactComponent as LalibrairieIcon } from '../../assets/icons/social/lalibrairie.svg'
import { SocialMediaPlatformEnum } from '../enums/media-platform.enum'

const socialIcons = {
  [SocialMediaPlatformEnum.INSTAGRAM]: InstagramIcom,
  [SocialMediaPlatformEnum.YOUTUBE]: YoutubeIcon,
  [SocialMediaPlatformEnum.FACEBOOK]: FacebookIcon,
  [SocialMediaPlatformEnum.TIKTOK]: TiktokIcom,
  [SocialMediaPlatformEnum.BABELIO]: BabelioIcon,
  [SocialMediaPlatformEnum.BOOKNODE]: BooknodeIcon,
  [SocialMediaPlatformEnum.LIVRADDICT]: LivraddictIcon,
  [SocialMediaPlatformEnum.GOODREADS]: GoodreadsIcon,
  [SocialMediaPlatformEnum.X]: XIcon,
  [SocialMediaPlatformEnum.BLUESKY]: BlueskyIcon,
  [SocialMediaPlatformEnum.GLEEPH]: GleephIcon,
  [SocialMediaPlatformEnum.AMAZON]: AmazonIcon,
  [SocialMediaPlatformEnum.FNAC]: FnacIcon,
  [SocialMediaPlatformEnum.DECITRE]: DecitreIcon,
  // [SocialMediaPlatformEnum.CULTURA]: null,
  [SocialMediaPlatformEnum.PLACE_DES_LIBRAIRES]: PlaceDesLibrairesIcon,
  [SocialMediaPlatformEnum.FURET_DU_NORD]: FuretDuNordIcon,
  [SocialMediaPlatformEnum.LALIBRAIRE]: LalibrairieIcon,
}

export const mappingBaseUrlToSocialIcon = {
  'https://www.instagram.com/': socialIcons.instagram,
  'https://www.youtube.com/': socialIcons.youtube,
  'https://www.facebook.com/': socialIcons.facebook,
  'https://www.tiktok.com/': socialIcons.tiktok,
  'https://www.babelio.com/': socialIcons.babelio,
  'https://booknode.com/': socialIcons.booknode,
  'https://www.livraddict.com/': socialIcons.livraddict,
  'https://www.goodreads.com/': socialIcons.goodreads,
  'https://x.com/': socialIcons.x,
  'https://bsky.app/': socialIcons.bluesky,
  'https://gleeph.com/': socialIcons.gleeph,
  'https://www.amazon.fr/': socialIcons.amazon,
  'https://www.fnac.com/': socialIcons.fnac,
  'https://www.decitre.fr/': socialIcons.decitre,
  // 'https://www.cultura.com/': socialIcons.cultura,
  'https://www.placedeslibraires.fr/': socialIcons.place_des_libraires,
  'https://www.furet.com/': socialIcons.furet_du_nord,
  'https://www.lalibrairie.com/': socialIcons.lalibrairie,
}

export const socialMediaBaseUrl = {
  X: 'https://x.com/',
  INSTAGRAM: 'https://www.instagram.com/',
  YOUTUBE: 'https://www.youtube.com/',
  FACEBOOK: 'https://www.facebook.com/',
  TIKTOK: 'https://www.tiktok.com/',
  BABELIO: 'https://www.babelio.com/',
  GOODREADS: 'https://www.goodreads.com/',
  LIVRADDICT: 'https://www.livraddict.com/',
  BLUESKY: 'https://bsky.app/',
  BOOKNODE: 'https://booknode.com/',
  GLEEPH: 'https://gleeph.com/',
}

export default socialIcons
